[
  {
    "id": "TB-B6P-001",
    "module": "Taalbegrip",
    "difficulty": 102,
    "question": "Lees het briefje:\n\n\"Lieve mama, ik ben bij Sem. We spelen in de tuin. Om 5 uur ben ik thuis. Kusje, Emma.\"\n\nWie heeft dit briefje geschreven?",
    "options": ["Emma", "Mama", "Sem", "Dat staat er niet"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "letterlijk_begrip",
    "familyId": "TB-BRIEFJE-EMMA",
    "explanation": "Onderaan het briefje staat 'Kusje, Emma'. Emma heeft het briefje geschreven aan haar mama.",
    "distractorExplanations": {
      "1": "Mama is degene voor wie het briefje bedoeld is.",
      "2": "Sem is de vriend bij wie Emma speelt.",
      "3": "Het staat er wel: 'Kusje, Emma'."
    }
  },
  {
    "id": "TB-B6P-002",
    "module": "Taalbegrip",
    "difficulty": 102,
    "question": "Lees de tekst:\n\n\"De hamster is een populair huisdier. Hij slaapt overdag en is 's nachts wakker. Hamsters leven gemiddeld 2 tot 3 jaar. Ze eten graag zaden, noten en groente.\"\n\nWanneer is een hamster het meest actief?",
    "options": ["'s Nachts", "Overdag", "'s Ochtends", "In de middag"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "letterlijk_begrip",
    "familyId": "TB-HAMSTER-ACTIEF",
    "explanation": "De tekst zegt: 'Hij slaapt overdag en is 's nachts wakker.' Dus hij is 's nachts het meest actief.",
    "distractorExplanations": {
      "1": "Overdag slaapt hij juist.",
      "2": "De ochtend valt onder 'overdag' — dan slaapt hij.",
      "3": "De middag valt onder 'overdag' — dan slaapt hij."
    }
  },
  {
    "id": "TB-B6P-003",
    "module": "Taalbegrip",
    "difficulty": 102,
    "question": "Lees het recept:\n\n\"Pannenkoeken (4 stuks)\nNodig: 200 g bloem, 3 eieren, 300 ml melk, snufje zout.\nMix alles door elkaar. Bak in een hete pan met boter.\"\n\nVoor hoeveel pannenkoeken is dit recept?",
    "options": ["4 stuks", "3 stuks", "200 stuks", "300 stuks"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "letterlijk_begrip",
    "familyId": "TB-RECEPT-PANNENKOEK",
    "explanation": "Achter de titel staat '(4 stuks)'. Het recept is voor 4 pannenkoeken.",
    "distractorExplanations": {
      "1": "3 is het aantal eieren, niet het aantal pannenkoeken.",
      "2": "200 is het aantal gram bloem.",
      "3": "300 is het aantal ml melk."
    }
  },
  {
    "id": "TB-B6P-004",
    "module": "Taalbegrip",
    "difficulty": 102,
    "question": "Lees de tekst:\n\n\"Olifanten zijn de grootste landdieren. Een volwassen olifant kan wel 6.000 kilo wegen. Ondanks hun grootte zijn ze heel voorzichtig. Ze stappen zachtjes om kleine dieren niet te vertrappen.\"\n\nWaarom stappen olifanten zachtjes?",
    "options": [
      "Om kleine dieren niet te vertrappen",
      "Omdat ze bang zijn",
      "Omdat ze moe zijn",
      "Omdat ze niet hard kunnen lopen"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "letterlijk_begrip",
    "familyId": "TB-OLIFANT-ZACHT",
    "explanation": "De tekst zegt: 'Ze stappen zachtjes om kleine dieren niet te vertrappen.'",
    "distractorExplanations": {
      "1": "De tekst zegt niet dat ze bang zijn.",
      "2": "Moeheid wordt niet genoemd.",
      "3": "Olifanten kunnen wel hard lopen."
    }
  },
  {
    "id": "TB-B6P-005",
    "module": "Taalbegrip",
    "difficulty": 102,
    "question": "Lees het bord:\n\n\"DIERENTUIN ARTIS\nOpen: ma-vr 9:00-17:00, za-zo 9:00-18:00\nKinderen t/m 12 jaar: € 15\nVolwassenen: € 25\nParkeren: gratis\"\n\nHoeveel kost een kaartje voor een kind van 10?",
    "options": ["€ 15", "€ 25", "Gratis", "€ 10"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "informatief_lezen",
    "familyId": "TB-ARTIS-PRIJS",
    "explanation": "Een kind van 10 valt onder 'Kinderen t/m 12 jaar: € 15'.",
    "distractorExplanations": {
      "1": "€ 25 is de prijs voor volwassenen.",
      "2": "Gratis is het parkeren, niet het kaartje.",
      "3": "€ 10 staat niet op het bord."
    }
  },
  {
    "id": "TB-B6P-006",
    "module": "Taalbegrip",
    "difficulty": 102,
    "question": "Lees de tekst:\n\n\"Zeesterren hebben een bijzondere eigenschap. Als ze een arm verliezen, groeit er een nieuwe aan. Sommige soorten kunnen zelfs een heel nieuw lichaam laten groeien uit één arm!\"\n\nWat is bijzonder aan zeesterren?",
    "options": [
      "Ze kunnen verloren armen laten teruggroeien",
      "Ze hebben vijf armen",
      "Ze leven in de zee",
      "Ze zijn heel groot"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "hoofdgedachte",
    "familyId": "TB-ZEESTER",
    "explanation": "De tekst noemt dit een 'bijzondere eigenschap': het teruggroeien van armen.",
    "distractorExplanations": {
      "1": "Het aantal armen wordt niet als bijzonder gepresenteerd.",
      "2": "Dat ze in de zee leven is niet het bijzondere punt.",
      "3": "Grootte wordt niet genoemd."
    }
  },
  {
    "id": "TB-B6P-007",
    "module": "Taalbegrip",
    "difficulty": 102,
    "question": "Wat betekent het woord 'eigenschap' in de zin: 'Zeesterren hebben een bijzondere eigenschap.'",
    "options": [
      "Iets wat kenmerkend is voor iemand of iets",
      "Iets wat je bezit",
      "Een huis of gebouw",
      "Een soort dier"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-WOORD-EIGENSCHAP",
    "explanation": "Een eigenschap is iets wat kenmerkend is. Bij zeesterren is dat het teruggroeien van armen.",
    "distractorExplanations": {
      "1": "Dat zou 'eigendom' of 'bezit' zijn.",
      "2": "Dat zou 'pand' of 'vastgoed' zijn.",
      "3": "Een eigenschap is geen diersoort."
    }
  },
  {
    "id": "TB-B6P-008",
    "module": "Taalbegrip",
    "difficulty": 102,
    "question": "Lees de tekst:\n\n\"De schoolkantine verkoopt vanaf maandag alleen nog gezonde snacks. Snoep en chips worden niet meer verkocht. De directeur zegt: 'We willen dat kinderen gezonder eten.'\"\n\nWat verandert er in de kantine?",
    "options": [
      "Er worden alleen nog gezonde snacks verkocht",
      "De kantine gaat dicht",
      "Alles wordt duurder",
      "Er komt een nieuwe directeur"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "letterlijk_begrip",
    "familyId": "TB-KANTINE",
    "explanation": "De tekst zegt: 'alleen nog gezonde snacks' en 'snoep en chips worden niet meer verkocht'.",
    "distractorExplanations": {
      "1": "De kantine gaat niet dicht, het aanbod verandert.",
      "2": "Prijzen worden niet genoemd.",
      "3": "Er komt geen nieuwe directeur."
    }
  },
  {
    "id": "TB-B6P-009",
    "module": "Taalbegrip",
    "difficulty": 102,
    "question": "Lees de tekst:\n\n\"Wolven leven in groepen die 'roedels' heten. De leider van de roedel heet de alfawolf. De roedel jaagt samen op grote dieren zoals herten.\"\n\nHoe heet een groep wolven?",
    "options": ["Een roedel", "Een kudde", "Een zwerm", "Een school"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-ROEDEL",
    "explanation": "De tekst zegt: 'groepen die roedels heten'.",
    "distractorExplanations": {
      "1": "Een kudde is voor koeien of paarden.",
      "2": "Een zwerm is voor bijen of vogels.",
      "3": "Een school is voor vissen."
    }
  },
  {
    "id": "TB-B6P-010",
    "module": "Taalbegrip",
    "difficulty": 102,
    "question": "Lees de uitnodiging:\n\n\"Je bent uitgenodigd voor het verjaardagsfeest van Liam!\nWanneer: zaterdag 15 maart, 14:00 - 17:00\nWaar: Lasergame Arena, Hoofdstraat 42\nGraag opgeven vóór woensdag!\"\n\nWaar is het feest?",
    "options": [
      "Lasergame Arena, Hoofdstraat 42",
      "Bij Liam thuis",
      "Op school",
      "In het park"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "informatief_lezen",
    "familyId": "TB-UITNODIGING",
    "explanation": "Bij 'Waar:' staat 'Lasergame Arena, Hoofdstraat 42'.",
    "distractorExplanations": {
      "1": "Er staat niet dat het bij Liam thuis is.",
      "2": "School wordt niet genoemd.",
      "3": "Het park wordt niet genoemd."
    }
  }
]